import React, { Fragment, useState } from "react";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Grid from "@mui/material/Grid";
import Catalogue from "./avatar";
import Search from "../../Search";
import { useSelector } from "react-redux";
import Skeleton from "components/Card Skeleton";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CheckIcon from "@mui/icons-material/Check";
import Chip from "@mui/material/Chip";
import Zoom from "@mui/material/Zoom";
import Tooltip from "@mui/material/Tooltip";
import { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { Divider } from "@mui/material";
import { Typography } from "antd";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Air } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import Rensair from "../../../assets/icons/rensair-logo.png";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "100%",
    fontSize: theme.typography.pxToRem(16),
    border: "1px solid #dadde9",
  },
  [`& .${tooltipClasses.arrow}`]: {
    backgroundColor: "rgba(0,0,0,0)",
    color: "#f5f5f9",
  },
}));

export default function CheckboxListSecondary(props) {
  const metaDataValue = useSelector((state) => state.metaData);
  const [filterFn, setFilterFn] = useState({ fn: (items) => items });

  function arrayUnique(array) {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  }
  function itemGenerator(array, x = 0, temp = [], end = false) {
    var a = array.concat();
    if (a.length == 1) return a[0];
    for (var i = 1; i < a.length; ++i) {
      if (end) {
        temp = arrayUnique(temp.concat(a[x]));
        i = a.length;
      } else {
        temp = arrayUnique(temp.concat(arrayUnique(a[x].concat(a[x + 1]))));
      }
      x += 2;
      if (x >= a.length - 1) {
        if (a.length % 2 == 0) {
          i = a.length;
        } else {
          end = true;
        }
      }
    }
    return temp;
  }

  // Search across name + friendlyName + description (widened from name-only).
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value == "") {
          props.parameters.forEach((prop) => delete prop.searched);
          return items;
        } else {
          var temp = [];
          ["name", "friendlyName", "description"].forEach((elm) => {
            temp.push(
              items.filter((x) =>
                (x[elm] || "").toLowerCase().includes(target.value.toLowerCase())
              )
            );
          });
          const matched = itemGenerator(temp);
          props.parameters.forEach((prop) => {
            if (matched.find((t) => t.id == prop.id)) prop.searched = true;
            else delete prop.searched;
          });
          return matched;
        }
      },
    });
  };

  const handleToggleAsset = (assetId) => {
    props.setSelectedAsset(assetId);
  };

  const AllowedMultiAsset = ["Monitoring", "Actuator"];

  // Selection mirrors the old card border: guard undefined/empty before includes.
  const isSelected = (id) =>
    props.selected != undefined && props.selected.length && props.selected.includes(id);
  // Toggle the exact same shape the old card onClick passed to handleToggle.
  const toggleRow = (elm) =>
    props.handleToggle({
      name: elm.name,
      id: elm.id,
      description: elm.description,
      image: elm.image,
      featureTabs: elm.featureTabs,
      friendlyName: elm?.friendlyName,
      operation: elm?.operation,
    });

  const multiAssetActive =
    AllowedMultiAsset.includes(props.name) &&
    props.allAssets &&
    props.allAssets.length > 1;

  const rows = filterFn.fn(props.parameters);
  const detailHeader =
    props.name === "Actuator" ? "Command" : props.name === "Monitoring" ? "Type" : "Tags";

  return (
    <div>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: "60%",
            minHeight: "calc(50vh - 19.875rem)",
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
          }}
        >
          <div style={{ flex: 1 }}>
            <Search handleSearch={handleSearch} />
          </div>
          {/* Explicit inline create button (replaces the floating FAB). Rendered
              only when the parent supplies an add handler and editing is allowed. */}
          {props.onAdd && !props.readOnly ? (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<AddIcon />}
              onClick={props.onAdd}
              style={{ whiteSpace: "nowrap" }}
            >
              {props.addLabel || "Add"}
            </Button>
          ) : null}
        </div>
      </span>
      <div>
        {props.loader ? (
          <Grid
            container
            style={{
              maxHeight: "18rem",
              overflowY: "scroll",
              overflowX: "hidden",
              marginBottom: "10rem",
            }}
          >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((k) => (
              <Grid item xs={3} key={k}>
                <Skeleton />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Fragment>
            <Grid container spacing={2}>
              {/* Multi-asset left rail (unchanged): pick the active asset; the
                  table's checkboxes reflect that asset's selection. */}
              {multiAssetActive && (
                <Grid
                  item
                  xs={12}
                  md={3}
                  padding={"1rem"}
                  display={"flex"}
                  gap={"0.5rem"}
                  style={{ maxHeight: "20rem" }}
                >
                  <Grid style={{ overflowY: "scroll", overflowX: "hidden", width: "100%" }}>
                    {props.allAssets.map((elm, ind) => {
                      let value = elm?.name;
                      let icon = elm?.icon;
                      let assetMapping = props.assetMapping.find(
                        (item) => item.assetId === elm.id
                      );
                      let label = "";
                      let count = 0;
                      if (props.name === "Monitoring") {
                        if (props.type && props.type === "valueInsight") {
                          count = assetMapping?.valueInsights?.length || 0;
                          label = "Number of Value Insight datapoints";
                        } else {
                          count = assetMapping?.sensors?.length || 0;
                          label = "Number of Datapoints";
                        }
                      } else if (props.name === "Actuator") {
                        count = assetMapping?.actuators?.length || 0;
                        label = "Number of Actuators";
                      }
                      let id = elm?.id;
                      let tags = elm?.tags;
                      let description = elm?.description;
                      let image = elm?.image;
                      return (
                        <Card
                          id={`asset-` + ind}
                          key={id}
                          style={{
                            margin: "10px 10px",
                            border:
                              props.selectedAsset === id
                                ? `2px solid ${metaDataValue.branding.secondaryColor}`
                                : `2px solid #f7f7f7`,
                            backgroundColor: "#f7f7f7",
                            boxShadow:
                              props.selectedAsset === id
                                ? ""
                                : "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                          }}
                          onClick={() => handleToggleAsset(id)}
                        >
                          <CardActionArea style={{ height: "6.813rem", position: "relative" }}>
                            {props.selectedAsset === id ? (
                              <div
                                style={{
                                  width: "0",
                                  height: "0",
                                  borderTop: `50px solid ${metaDataValue.branding.secondaryColor}`,
                                  borderRight: "50px solid transparent",
                                  position: "absolute",
                                  top: "0",
                                  left: "0",
                                }}
                              >
                                <CheckIcon
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    position: "relative",
                                    color: "white",
                                    bottom: "32px",
                                    left: "15px",
                                  }}
                                />
                              </div>
                            ) : null}
                            <div style={{ margin: "10px" }}>
                              <span>
                                <Catalogue
                                  zoomOut={props.zoomOut}
                                  title={elm?.friendlyName ? elm?.friendlyName : value}
                                  parameters={tags}
                                  image={image}
                                  icon={icon}
                                  description={description}
                                />
                              </span>
                            </div>
                            <Tooltip title={label} placement="bottom" arrow TransitionComponent={Zoom}>
                              <Chip
                                size="small"
                                color="secondary"
                                label={count ? count : 0}
                                variant="outlined"
                                style={{ position: "absolute", top: "10px", right: "10px" }}
                              />
                            </Tooltip>
                            {elm.config ? (
                              <SettingsOutlinedIcon
                                color="primary"
                                style={{ position: "absolute", bottom: "10px", left: "10px" }}
                              />
                            ) : null}
                          </CardActionArea>
                        </Card>
                      );
                    })}
                  </Grid>
                  <Divider orientation="vertical" flexItem sx={{ mr: "-0.063rem" }} />
                </Grid>
              )}

              {/* Selection TABLE (replaces the paginated card grid). All rows,
                  scrollable — no per-page clicks. */}
              <Grid
                item
                xs={12}
                md={multiAssetActive ? 9 : 12}
                style={{
                  height: !AllowedMultiAsset.includes(props.name)
                    ? "calc(50vh - 4.875rem)"
                    : "18.3rem",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {rows.length ? (
                  <TableContainer>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell padding="checkbox" style={{ backgroundColor: "#e2e2e2" }} />
                          <TableCell style={{ backgroundColor: "#e2e2e2" }}>Name</TableCell>
                          <TableCell style={{ backgroundColor: "#e2e2e2" }}>Description</TableCell>
                          <TableCell style={{ backgroundColor: "#e2e2e2" }}>{detailHeader}</TableCell>
                          {props.usageMap ? (
                            <TableCell align="center" style={{ backgroundColor: "#e2e2e2" }}>
                              <Tooltip title="Number of solutions this is configured in">
                                <span>Solutions</span>
                              </Tooltip>
                            </TableCell>
                          ) : null}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((elm, ind) => {
                          const id = elm.id;
                          const selected = !!isSelected(id);
                          const title = elm?.friendlyName ? elm.friendlyName : elm.name;
                          const detail =
                            props.name === "Actuator"
                              ? elm?.command
                              : (elm?.tags && elm.tags[0]) || "";
                          return (
                            <TableRow
                              key={id || ind}
                              hover
                              selected={selected}
                              onClick={props.readOnly ? undefined : () => toggleRow(elm)}
                              style={{ cursor: props.readOnly ? "default" : "pointer" }}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  color="secondary"
                                  checked={selected}
                                  disabled={props.readOnly}
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={props.readOnly ? undefined : () => toggleRow(elm)}
                                />
                              </TableCell>
                              <TableCell>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                  {elm.aqdt ? (
                                    <span style={{ display: "flex", gap: 4, alignItems: "center" }}>
                                      <img
                                        src={Rensair}
                                        style={{ width: 40, height: 16, objectFit: "contain" }}
                                        alt=""
                                      />
                                      <Air fontSize="small" />
                                    </span>
                                  ) : null}
                                  <span style={{ fontWeight: 500 }}>{title}</span>
                                  {elm.config ? (
                                    <Tooltip title="Configuration datapoint">
                                      <SettingsOutlinedIcon color="primary" fontSize="small" />
                                    </Tooltip>
                                  ) : null}
                                </div>
                              </TableCell>
                              <TableCell>
                                <Tooltip title={elm.description || ""}>
                                  <span
                                    style={{
                                      display: "inline-block",
                                      maxWidth: 260,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      color: "grey",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    {elm.description}
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell>
                                {props.name === "Monitoring" && elm.operation ? (
                                  <HtmlTooltip title={<Fragment>{elm.operation}</Fragment>} placement="bottom" arrow>
                                    <Chip size="small" color="secondary" label={detail} variant="outlined" />
                                  </HtmlTooltip>
                                ) : detail ? (
                                  <Tooltip title={detail}>
                                    <Chip size="small" color="secondary" label={detail} variant="outlined" />
                                  </Tooltip>
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                              {props.usageMap ? (
                                <TableCell align="center">
                                  <Chip
                                    size="small"
                                    variant="outlined"
                                    label={props.usageMap[id] || 0}
                                  />
                                </TableCell>
                              ) : null}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: 22,
                      margin: "35px 0px",
                      width: "100%",
                      fontWeight: 500,
                    }}
                  >
                    No Search Results
                  </div>
                )}
              </Grid>

              {/* Multi-asset selected-datapoint chips (unchanged). */}
              {AllowedMultiAsset.includes(props.name) && (
                <Grid
                  container
                  textAlign={"center"}
                  minHeight={"calc(50vh - 21.875rem)"}
                  marginTop={"3rem"}
                  overflow={"auto"}
                  display={"block"}
                >
                  <Grid item md={12}>
                    {props?.selectedAssetIndex != undefined &&
                      props?.selectedAssetIndex !== -1 &&
                      props.selected.map((elm) => {
                        let datapoint =
                          props.uniqueSelected &&
                          props.uniqueSelected.find((obj) => obj?.id === elm || obj?._id === elm);
                        return (
                          <Chip
                            key={elm}
                            sx={{ "& .MuiChip-deleteIcon": { color: "white" } }}
                            size="small"
                            color="secondary"
                            label={datapoint?.friendlyName ? datapoint?.friendlyName : datapoint?.name}
                            variant="filled"
                            onDelete={props.readOnly ? undefined : () => props.handleToggle(datapoint)}
                            style={{ background: "#008000", color: "white", margin: "0.3rem" }}
                          />
                        );
                      })}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Fragment>
        )}
      </div>
      {AllowedMultiAsset.includes(props.name) && (
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography
            style={{ fontSize: "100%", fontWeight: 700, lineHeight: "23px", color: "#D3D3D3" }}
          >
            Selected {props.name == "Monitoring" ? "Datapoints" : "Actuators"} (
            {props?.selectedAssetIndex != undefined &&
            props?.selectedAssetIndex !== -1 &&
            props.selected.length
              ? props.selected.length
              : 0}
            )
          </Typography>
        </span>
      )}
    </div>
  );
}
